export enum QuickViewMode {
  CREATION,
  EDITION,
}
